<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >监控告警</el-breadcrumb-item>
          <el-breadcrumb-item >耗材告警</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <div class="table-content">
          <div class="header-common" >
            <div class="header-common-left">
              <div class="title">耗材告警列表</div>
            </div>
            <div class="header-common-right">
              <el-button
                class="right-button-export"
                @click="exportTable()"
                type="text"
                >
                导出
              </el-button>
            </div>
          </div>
          <div class="table-list">
            <el-table
              v-loading='loading'
              border
              style="width: 100%;"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              :max-height="tableHeight"
              :data="tableData.filter(data => !search || data.provinceName.toLowerCase().includes(search.toLowerCase())  || data.name.toLowerCase().includes(search.toLowerCase()))"

              >

              <el-table-column
                  type="index"
                  label="序号">
                </el-table-column>
                <el-table-column
                  prop="provinceName"
                  label="所在地区">
                  <template slot-scope="scope">
                    {{scope.row.provinceName}}/{{scope.row.cityName}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="name"
                  label="使用单位">
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="耗材剩余数量">
                  <template slot-scope="scope">
                    <!-- <el-tag @click="" class="hander" v-if="scope.row.stockThreshold<scope.row.amount">{{scope.row.amount}}</el-tag> -->
                    <!-- <p v-else>{{scope.row.amount}}</p> -->
                    <router-link v-if="scope.row.stockThreshold>scope.row.amount" class="hander-warning" :to="{path:'/monitor/consumables/consumables-monitor-hospital',query:{id:scope.row.id}}">
                      {{scope.row.amount}}
                    </router-link>
                    <router-link v-else class="hander" :to="{path:'/monitor/consumables/consumables-monitor-hospital',query:{id:scope.row.id}}">
                      {{scope.row.amount}}
                    </router-link>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作"
                  width="230">
                  <template slot="header" slot-scope="scope">
                    <el-input
                      id="search"
                      v-model="search"
                      size="mini"
                      placeholder="输入关键字搜索"/>
                  </template>
                  <template slot-scope="scope">
                      <router-link class="action-button-base" :to="{path:'/monitor/consumables/consumables-monitor-hospital',query:{id:scope.row.id}}">
                        使用单位详情
                      </router-link>
                  </template>
                </el-table-column>
              </el-table>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import {dataConversionUtil} from '../../../utils/excel.js'
  import {areaSimplifyConversionUtil} from '../../../utils/povince_handle.js'

  export default {
    data() {
      return {
        search:"",
        tableData:[],
        loading:false,
        moreTableData:[],
        tableHeight:0,
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;margin-right:5px;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;margin-right:5px;'
      },
      getConsumablesList(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/hospital/consumable/list'

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.hospitals){
                // 获取设备数据
                this.tableData = obj.data.hospitals;
                areaSimplifyConversionUtil.codeToName(this.tableData);
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      exportTable(){
        var tableHeader = [['序号','所在地区','使用单位','耗材剩余数量']];
        var dataList = [];
        var documentName = '耗材告警列表'
        this.tableData.forEach((item,index)=>{
          dataList.push([
            index+1,
            item.provinceName,
            item.name,
            item.amount
          ]);
        });
        
        if(dataList.length > 0){
          dataConversionUtil.dataToExcel(documentName,tableHeader,dataList)
          this.$message.success('导出成功')
        }else{
          this.$message.warning('无数据导出')
        }
        
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-215 < 300 ? 300 : window.innerHeight-215;
        })
      },
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)

      this.sizeFun()
      this.getConsumablesList()
    },
    created() {


    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)

    }
  }

</script>


<style lang="scss" scoped>
.container {
  margin-top: $header-height;

  .table-content{
    // margin-top: $main-padding;
    // position: fixed;
    // top: $header-height+50px;
    // right: 20px;
    // left: 230px;
    // bottom: $main-padding;

    .header-common{
      height: 45px;
      border-radius: 12px 12px 0 0;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .header-common-left{
        font-size: 20px;
        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;
      }

      .header-common-right{

        .right-button{
          width: 89px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          background-color: #208D7F;
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-export{
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-base{
          width: 89px;
          height: 40px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          background-color: #208D7F;
          font-size: 14px;
          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
          display: inline-block;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
        }
      }
    }

    .table-list{

      .hander-warning{
        // cursor: pointer;
        color: #000;
        // background-color: #104C90;
        background-color: orange;
        border: 0px;
        text-decoration: none;
        padding: 10px;
        border-radius: 10px;
      }
      .hander{
        // cursor: pointer;
        color: #fff;
        // background-color: #104C90;
        border: 0px;
        text-decoration: none;
      }


      .action-button-base{
        width:120px;
        height: 36px;
        background: #FAFAFA;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 20px;
        background-color: #20478D;
        font-size: 14px;
        font-weight: 400;
        color: #00DEFF;
        display: inline-block;
        line-height: 36px;
        text-align: center;
        text-decoration: none;
      }
    }

  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    margin: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/monitor/consumables/consumables-monitor.vue